import React from 'react';
import { Navigation } from './Navigation';

interface LayoutProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  onLogout?: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ children, isAuthenticated, onLogout }) => {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      <Navigation isAuthenticated={isAuthenticated} onLogout={onLogout} />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <footer className="border-t border-gray-800 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <p className="text-center text-gray-400 text-sm">
            Atlas OSINT Brasil • Plataforma de Pesquisa e Investigação Digital
          </p>
        </div>
      </footer>
    </div>
  );
};
